import { render, staticRenderFns } from "./ShortFormAPI.vue?vue&type=template&id=76a57c00&scoped=true&"
import script from "./ShortFormAPI.vue?vue&type=script&lang=js&"
export * from "./ShortFormAPI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a57c00",
  null
  
)

export default component.exports